import { IconPropsType } from "./type";

export const AristoByteUI = ({ size = 24 }: IconPropsType) => (
  <svg
    width={size}
    height={size}
    id="layer-1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 918.18 1038.19"
  >
    <defs>
      <filter
        id="drop-shadow-1"
        x="-4.39"
        y="347.5"
        width="927"
        height="658"
        filterUnits="userSpaceOnUse"
      >
        <feOffset dx="0" dy="10.17" />
        <feGaussianBlur result="blur" stdDeviation="38.66" />
        <feFlood floodColor="#000" floodOpacity=".61" />
        <feComposite in2="blur" operator="in" />
        <feComposite in="SourceGraphic" />
      </filter>
      <linearGradient
        id="_gradient_54"
        x1="111.59"
        y1="765.68"
        x2="806.58"
        y2="765.68"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#ff4a01" />
        <stop offset=".18" stopColor="#f04311" />
        <stop offset=".36" stopColor="#e32c01" />
        <stop offset=".55" stopColor="#fb3c01" />
        <stop offset=".7" stopColor="#fa2903" />
        <stop offset=".86" stopColor="#ee2404" />
        <stop offset="1" stopColor="#cf1809" />
      </linearGradient>
      <linearGradient
        id="_gradient_46"
        x1="111.59"
        y1="651.81"
        x2="806.59"
        y2="651.81"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#ff4a01" />
        <stop offset=".18" stopColor="#e82c02" />
        <stop offset=".36" stopColor="#ec2d01" />
        <stop offset=".55" stopColor="#e12502" />
        <stop offset=".7" stopColor="#d21f04" />
        <stop offset=".86" stopColor="#ce1c05" />
        <stop offset="1" stopColor="#e51f07" />
      </linearGradient>
      <filter
        id="drop-shadow-2"
        x="-4.39"
        y="204.5"
        width="927"
        height="658"
        filterUnits="userSpaceOnUse"
      >
        <feOffset dx="0" dy="10.17" />
        <feGaussianBlur result="blur-2" stdDeviation="38.66" />
        <feFlood floodColor="#000" floodOpacity=".61" />
        <feComposite in2="blur-2" operator="in" />
        <feComposite in="SourceGraphic" />
      </filter>
      <linearGradient
        id="_gradient_84"
        x1="111.59"
        y1="623.26"
        x2="806.58"
        y2="623.26"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#fb8206" />
        <stop offset=".18" stopColor="#fda12d" />
        <stop offset=".54" stopColor="#f85502" />
        <stop offset="1" stopColor="#f33101" />
      </linearGradient>
      <linearGradient
        id="_gradient_38"
        x1="111.59"
        y1="509.4"
        x2="806.59"
        y2="509.4"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#ff9505" />
        <stop offset=".18" stopColor="#ff6c01" />
        <stop offset=".36" stopColor="#fe5e01" />
        <stop offset=".54" stopColor="#f33301" />
        <stop offset=".7" stopColor="#f32f01" />
        <stop offset=".86" stopColor="#f72f01" />
        <stop offset="1" stopColor="#ef2d01" />
      </linearGradient>
      <filter
        id="drop-shadow-3"
        x="-4.39"
        y="62.5"
        width="927"
        height="658"
        filterUnits="userSpaceOnUse"
      >
        <feOffset dx="0" dy="10.17" />
        <feGaussianBlur result="blur-3" stdDeviation="38.66" />
        <feFlood floodColor="#000" floodOpacity=".61" />
        <feComposite in2="blur-3" operator="in" />
        <feComposite in="SourceGraphic" />
      </filter>
      <linearGradient
        id="_gradient_31"
        x1="111.59"
        y1="366.98"
        x2="806.59"
        y2="366.98"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#ffda09" />
        <stop offset=".18" stopColor="#ffd001" />
        <stop offset=".36" stopColor="#ffb900" />
        <stop offset=".54" stopColor="#ffae00" />
        <stop offset=".7" stopColor="#ff9501" />
        <stop offset=".86" stopColor="#ff9101" />
        <stop offset="1" stopColor="#ff8001" />
      </linearGradient>
    </defs>
    <g id="logo">
      <g id="g-3" filter="url(#drop-shadow-1)">
        <path
          d="M805.95,658.84c-3.21,15.5-31.29,28.1-44.28,35.56-87.39,50.22-176.71,97.19-264.1,147.41-22.03,11.01-50.49,10.93-73.26,2.05-74.28-41.36-148.5-82.88-222.7-124.32-6.85-3.83-13.28-8.44-20.47-11.6-.54-1.73-2.36-1.5-3.41-2.05-.44-.23-.95-.45-1.36-.68l-1.36-1.36c-14.33-8.23-48.14-24.15-56.93-36.22-3.89-5.34-5.86-10.28-6.34-14.85v23.54c-.18,1.6-.18,3.25.02,4.95.53,4.51,2.5,9.37,6.33,14.63,8.79,12.08,42.6,27.99,56.93,36.22l1.36,1.36c.41.23.92.46,1.36.68,1.06.54,2.87.31,3.41,2.05,7.2,3.16,13.62,7.77,20.47,11.6,74.2,41.44,148.43,82.96,222.7,124.32,22.76,8.88,51.22,8.96,73.26-2.05,87.4-50.22,176.71-97.19,264.1-147.41,12.99-7.46,41.07-20.06,44.28-35.56.89-4.27.81-8.03,0-11.39v-16.88Z"
          fill="url(#_gradient_54)"
        />
        <path
          id="surf-3"
          d="M688.87,570.09c31.95,18.14,66.2,36.69,97.37,55.84,12.27,7.54,23.13,16.42,19.71,32.91-3.21,15.5-31.29,28.1-44.28,35.56-87.39,50.22-176.71,97.19-264.1,147.41-22.03,11.01-50.49,10.93-73.26,2.05-74.28-41.36-148.5-82.88-222.7-124.32-6.85-3.83-13.28-8.44-20.47-11.6-.54-1.73-2.36-1.5-3.41-2.05-.44-.23-.95-.45-1.36-.68l-1.36-1.36c-14.33-8.23-48.14-24.15-56.93-36.22-15.3-21.02-.97-35.81,16.89-46.47,92.97-55.48,189.91-104.73,283.21-159.7,7.97-3.8,14.29-5.39,22.98-6.7l2.05-.68c15.96-1.92,35.3-.34,50.06,6.24,64.75,37.32,130.78,72.96,195.62,109.78Z"
          fill="url(#_gradient_46)"
        />
      </g>
      <g id="g-2" filter="url(#drop-shadow-2)">
        <path
          id="surf-shadow-2"
          d="M805.95,516.43c-3.21,15.5-31.29,28.1-44.28,35.56-87.39,50.22-176.71,97.19-264.1,147.41-22.03,11.01-50.49,10.93-73.26,2.05-74.28-41.36-148.5-82.88-222.7-124.32-6.85-3.83-13.28-8.44-20.47-11.6-.54-1.73-2.36-1.5-3.41-2.05-.44-.23-.95-.45-1.36-.68l-1.36-1.36c-14.33-8.23-48.14-24.15-56.93-36.22-3.89-5.34-5.86-10.28-6.34-14.85v23.54c-.18,1.6-.18,3.25.02,4.95.53,4.51,2.5,9.37,6.33,14.63,8.79,12.08,42.6,27.99,56.93,36.22l1.36,1.36c.41.23.92.46,1.36.68,1.06.54,2.87.31,3.41,2.05,7.2,3.16,13.62,7.77,20.47,11.6,74.2,41.44,148.43,82.96,222.7,124.32,22.76,8.88,51.22,8.96,73.26-2.05,87.4-50.22,176.71-97.19,264.1-147.41,12.99-7.46,41.07-20.06,44.28-35.56.89-4.27.81-8.03,0-11.39v-16.88Z"
          fill="url(#_gradient_84)"
        />
        <path
          id="surf-2"
          d="M688.87,427.67c31.95,18.14,66.2,36.69,97.37,55.84,12.27,7.54,23.13,16.42,19.71,32.91-3.21,15.5-31.29,28.1-44.28,35.56-87.39,50.22-176.71,97.19-264.1,147.41-22.03,11.01-50.49,10.93-73.26,2.05-74.28-41.36-148.5-82.88-222.7-124.32-6.85-3.83-13.28-8.44-20.47-11.6-.54-1.73-2.36-1.5-3.41-2.05-.44-.23-.95-.45-1.36-.68l-1.36-1.36c-14.33-8.23-48.14-24.15-56.93-36.22-15.3-21.02-.97-35.81,16.89-46.47,92.97-55.48,189.91-104.73,283.21-159.7,7.97-3.8,14.29-5.39,22.98-6.7l2.05-.68c15.96-1.92,35.3-.34,50.06,6.24,64.75,37.32,130.78,72.96,195.62,109.78Z"
          fill="url(#_gradient_38)"
        />
      </g>
      <g id="g-1" filter="url(#drop-shadow-3)">
        <path
          id="surf-shadow-1"
          d="M805.95,374.01c-3.21,15.5-31.29,28.1-44.28,35.56-87.39,50.22-176.71,97.19-264.1,147.41-22.03,11.01-50.49,10.93-73.26,2.05-74.28-41.36-148.5-82.88-222.7-124.32-6.85-3.83-13.28-8.44-20.47-11.6-.54-1.73-2.36-1.5-3.41-2.05-.44-.23-.95-.45-1.36-.68l-1.36-1.36c-14.33-8.23-48.14-24.15-56.93-36.22-3.89-5.34-5.86-10.28-6.34-14.85v23.54c-.18,1.6-.18,3.25.02,4.95.53,4.51,2.5,9.37,6.33,14.63,8.79,12.08,42.6,27.99,56.93,36.22l1.36,1.36c.41.23.92.46,1.36.68,1.06.54,2.87.31,3.41,2.05,7.2,3.16,13.62,7.77,20.47,11.6,74.2,41.44,148.43,82.96,222.7,124.32,22.76,8.88,51.22,8.96,73.26-2.05,87.4-50.22,176.71-97.19,264.1-147.41,12.99-7.46,41.07-20.06,44.28-35.56.89-4.27.81-8.03,0-11.39v-16.88Z"
          fill="#ff9602"
        />
        <g id="surf-1">
          <path
            d="M688.87,285.26c31.95,18.14,66.2,36.69,97.37,55.84,12.27,7.54,23.13,16.42,19.71,32.91-3.21,15.5-31.29,28.1-44.28,35.56-87.39,50.22-176.71,97.19-264.1,147.41-22.03,11.01-50.49,10.93-73.26,2.05-74.28-41.36-148.5-82.88-222.7-124.32-6.85-3.83-13.28-8.44-20.47-11.6-.54-1.73-2.36-1.5-3.41-2.05-.44-.23-.95-.45-1.36-.68l-1.36-1.36c-14.33-8.23-48.14-24.15-56.93-36.22-15.3-21.02-.97-35.81,16.89-46.47,92.97-55.48,189.91-104.73,283.21-159.7,7.97-3.8,14.29-5.39,22.98-6.7l2.05-.68c15.96-1.92,35.3-.34,50.06,6.24,64.75,37.32,130.78,72.96,195.62,109.78Z"
            fill="url(#_gradient_31)"
          />
        </g>
      </g>
    </g>
  </svg>
);
